import React from "react";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      “Tilín, tilín, sonaban unas laminitas de metal colgadas sobre los cercados del palacio del Zipa. Tilín, tilín cada
      vez que pasaba un poquito de viento”.
    </p>
    <p className="content justified">
      Con estas palabras Oswaldo Díaz Díaz crea la atmósfera para el cuento “El cargador de sal”, una de las obras más
      emblemáticas de su carrera cuentística y que además fue llevada al radioteatro infantil.
    </p>
    <p className="content justified">
      La fragancia, la temperatura, el viento y el agotamiento nutren el espacio que habita el lector y así presenciamos
      cómo la humedad y el sueño hacen que el pequeño Zuhé deje a un lado su atado de sal y cierre los ojos. El niño
      está tan cansado, que ni siquiera despierta con la lluvia.
    </p>
    <p className="content justified">
      Pero la lluvia, que no se lleva el sueño, sí licúa el atado de sal, que desaparece con el agua. Zuhé despierta
      descansado, pero al ver que ha perdido su carga llora desconsolado e invoca a su dios, Bochica.
    </p>
  </div>
);

export const bottomParagraph = (
  <div className="bottomParagraph">
    <p className="content justified">
      Con un ritmo constante, párrafos cortos, imágenes vívidas y diálogos atinados, Oswaldo Díaz Díaz nos muestra el
      camino que el pequeño Zuhé y Bochica siguen para recuperar la sal perdida: vuelan, se sumergen en la laguna
      sagrada donde las ofrendas al dios son idolitos de oro, perlas y esmeraldas.
    </p>
    <p className="content justified">
      El mundo subterráneo se abre después a sus pies y atraviesan cavernas, pozos de petróleo y fósiles prehistóricos
      para llegar, al fin, al océano “con sus olas enormes, sus constantes mareas, sus caracoles rosados, su espuma y su
      eterna canción”.
    </p>
    <p className="content justified">
      Es allí donde el dios Bochica le enseña al niño a sacar la sal del mar y, tras recuperar la carga perdida,
      regresan a las montañas andinas con el atadito lleno y el espíritu alegre. Finalmente Zuhé se postra para
      agradecer a Bochica, pero cuando se levanta no encuentra más que un idolito de oro que el dios le deja de regalo.
    </p>
    <p className="content justified">
      Esta breve narración, que pendula entre lo fantástico y lo histórico, se ensalza aún más en la edición de 1967 del
      libro <i>Cuentos tricolores</i>, donde las ilustraciones de Sergio Trujillo Magnenat la llenan de magnificencia y
      esplendor.
    </p>
    <p className="content justified">
      Cabe destacar, además, el interés de Oswaldo Díaz Díaz por incluir entre sus protagonistas a un niño indígena como
      el pequeño Zuhé, en un momento en el que los personajes de la mayor parte de las historias infantiles colombianas
      eran niños urbanos, de tez blanca y costumbres modernas. Don Os da una voz a quienes fueron silenciados en la
      colonia e intenta recrear una historia que bien pudo haber nacido en la tradición oral chibcha.
    </p>
  </div>
);

export const sections = <div className="sectionsReview"></div>;
